module.exports = __webpack_public_path__ + "static/media/LV.fba77e13.svg";